import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Card, Collection, Heading, Image, View } from '@aws-amplify/ui-react';
import { GraphQLErrorResponse } from '@components/pages/commonType';
import { Hidden, Typography } from '@mui/material';
import 'dayjs/locale/ja';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { getAreaListApi } from '@apis/index';
import { MessageDialogState } from '@atom/DialogState';
import { LoadingState } from '@atom/LoadingState';
import { FacilityState } from '@atom/FacilityState';

import { GetAreaListQueryVariables } from '../../../API';
import PageBase from '../PageBase';

const AreaListPage = () => {
  /* 共通State */
  const setMessageDialogState = useSetRecoilState(MessageDialogState);
  const setLoading = useSetRecoilState(LoadingState);

  // Recoilステート
  const facility = useRecoilValue(FacilityState);
  const { facilityId } = facility;

  // TODO 型をインポートして追加
  const [areaList, setAreaList] = useState<any>('');
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    try {
      const input: GetAreaListQueryVariables = {
        input: {
          facilityId
        }
      };

      // データ取得
      const result = await getAreaListApi(input);
      setAreaList(result);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in (error as GraphQLErrorResponse) && (error as GraphQLErrorResponse).errors.length !== 0) {
        message = (error as GraphQLErrorResponse).errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (facilityId) {
      getData();
    }
  }, [facilityId]);

  return (
    <PageBase title="エリア選択" subTitle="予約したいエリアを選択してください。" isButton={false}>
      {areaList ? (
        <Collection
          items={areaList.floorList}
          type="list"
          direction="column"
          gap="20px"
          wrap="nowrap"
          alignItems="center"
        >
          {(item: any, index) => (
            <>
              <Heading style={{ alignSelf: 'flex-start' }} padding="medium" textAlign="left">
                {item.floor}
              </Heading>
              {item.areaList.map((value: any) => (
                <Card
                  key={index}
                  borderRadius="medium"
                  width="90%"
                  variation="outlined"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    navigate(
                      `/c001/weeklyschedule/?facilityId=${areaList.facilityId}&areaId=${value.areaId}&title=${value.areaName}`
                    )
                  }
                >
                  <View style={{ display: 'flex', flexDirection: 'row' }}>
                    <View style={{ width: '40%', marginRight: '20px' }}>
                      <Image alt="" src={`/images/${facilityId}/area/${value.areaImagePath}`} width="100%" />
                    </View>

                    <View style={{ width: '60%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Heading>{value.areaName}</Heading>
                        <br />
                        <Typography>(1時間あたり/税込) {value.minFee}円 〜</Typography>
                      </div>

                      <Hidden smDown>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography style={{ whiteSpace: 'pre-line' }}>{value.explanation}</Typography>
                        </div>
                      </Hidden>
                    </View>
                  </View>
                </Card>
              ))}
            </>
          )}
        </Collection>
      ) : (
        ''
      )}
    </PageBase>
  );
};

export default AreaListPage;
